export const requestedLine = (canBuy: boolean, requestedTotal: number) => {
  if (canBuy) {
    return requestedTotal === 1
      ? 'Add the invitation to the requested list. Buy seat and it goes out automatically.'
      : 'Add the invitations to the requested list. Buy seats and they go out automatically.'
  }
  return requestedTotal === 1 ? 'The invitation will be added to the requested list.' : 'The invitations will be added to the requested list.'
}
